import {
  initChatMessages,
  readChatMessages,
  SubscribeMessage,
  updateChatMessages
} from '@modules/chatMessages';
import { useCallback } from 'react';
import { useDispatch, useSelector } from '@store';

const useChatMessages = () => {
  const dispatch = useDispatch();

  const onInitChatMessages = useCallback(() => dispatch(initChatMessages()), [
    dispatch
  ]);

  const onUpdateChatMessages = useCallback(
    (payload: SubscribeMessage) => dispatch(updateChatMessages(payload)),
    [dispatch]
  );

  const onReadChatMessages = useCallback(() => dispatch(readChatMessages()), [
    dispatch
  ]);

  const chatMessages = useSelector((state) => state.chatMessages);

  return {
    chatMessages,
    onReadChatMessages,
    onInitChatMessages,
    onUpdateChatMessages
  };
};

export default useChatMessages;
